import React from 'react';
import { useEffect } from 'react';
import { connect } from "react-redux";

import HeaderComponent from '../../common/HeaderComponent/HeaderComponent';
import BottomAppBarComponent from '../../common/BottomAppBarComponent/BottomAppBarComponent';
import FooterComponent from '../../common/FooterComponent/FooterComponent';
import "./ContactusComponent.css";
import { getTempleDetails } from '../../store/actions/book.js';

import {
    Box,
    Container
} from '@mui/material';

const  ContactusComponent = ({getTempleDetails, templeDetails}) => {
    useEffect(() => {
        getTempleDetails(); // Fetch temple details on component mount
    }, [getTempleDetails]);

    return (
        <>
            <HeaderComponent />
            < Box className="puja-gallery-page">
                <Container sx={{ px: 1 }}>
                <div className='div-space'>
                <h3 class="puja-details">Address:</h3>
                <p class="sub-title"> 18/29 16th Street, <br/> 
                    TG Nagar,<br/>
                    Nanganallur, <br/>
                    Chennai <br/>
                    INDIA <br/>
                    600061 
                </p>
                </div>


                <div className='div-space'>
                <h3 class="puja-details">Contact:</h3>
                <strong>Phone: </strong>  {templeDetails?.SupportNumber || "N/A"} <br/>
                <strong>Email: </strong> <a href="mailto:sridevitemple@gmail.com">sridevitemple@gmail.com</a>
                </div>
                </Container>
            </Box>


            <FooterComponent />
            <BottomAppBarComponent />
        </>
    )

}

const mapStateToProps = (state) => ({
  templeDetails: state.book.templeDetails
});

export default connect(mapStateToProps, { getTempleDetails })(ContactusComponent);